const formatCelular = (telefone) =>
  telefone.replace(/(^0?\d{2})(\d{5})(\d{4})/, "($1) $2-$3");

export default formatCelular;
